export default {
	meta: {
		title: 'Ajout des paiements',
		description: 'Ajout des paiements'
	},
	sourceConfig: {
		'access-master': {
			type: {
				remuneration:
					{
						urls: {
							fetchHistory: '/api/generic-imports/type/remuneration',
							addFile: '/api/generic-imports/type/remuneration',
							findImportedFile: '/api/generic-imports/type/remuneration/latest',
							fetchImportedFile: '/api/generic-imports/type/remuneration/latest',
							cancelImportedFileAsync: '/api/generic-imports/{genericImportId}/async',
							deleteImportedFile: '/api/generic-imports/{genericImportId}',
							exportImportedFile: '/api/generic-imports/{genericImportId}/file/{status}',
							importFile: '/api/generic-imports/{genericImportId}',
							uploadFile: '/file/upload/remuneration',
							genericImportConfig: '/api/generic-imports/type/remuneration/configurations'
						},
						importValidationSuccess: 'Pas de lignes OK dans le fichier | Import de la ligne OK en cours | Import des {count} lignes OK en cours',
						importArchivedSuccess: 'Aucune ligne à sauvegarder dans le fichier | La ligne est sauvegardée | Les {count} lignes sont sauvegardées',
						dataLoadedSuccess: 'Pas de lignes OK dans le fichier | Enregistrement de la ligne OK réussie | Enregistrement des {count} lignes OK réussi',
						validatedBloc: {
							successRows: 'Import de {successCount} lignes sur {rowsCount} en cours',
							importFinished: 'Import validé'
						},
						explanation: 'Le fichier apparaitra dans l’historique après calcul des paiements',
						importValidatedDeleted: 'L’annulation a été effectuée avec succès',
						downloadingInfoTooltip: 'La durée d’enregistrement des données dépend de la volumétrie du fichier importé'
					},
				patient:
					{
						urls: {
							fetchHistory: '/api/generic-imports/type/patient',
							addFile: '/api/generic-imports/type/patient',
							findImportedFile: '/api/generic-imports/type/patient/latest',
							fetchImportedFile: '/api/generic-imports/type/patient/latest',
							cancelImportedFileAsync: '/api/generic-imports/{genericImportId}/async',
							deleteImportedFile: '/api/generic-imports/{genericImportId}',
							exportImportedFile: '/api/generic-imports/{genericImportId}/file/{status}',
							importFile: '/api/generic-imports/{genericImportId}',
							uploadFile: '/file/upload/patient',
							genericImportConfig: '/api/generic-imports/type/patient/configurations'
						},
						importValidationSuccess: 'Pas de lignes OK dans le fichier | Import de la ligne OK en cours | Import des {count} lignes OK en cours',
						importArchivedSuccess: 'Aucune ligne à sauvegarder dans le fichier | La ligne est sauvegardée | Les {count} lignes sont sauvegardées',
						dataLoadedSuccess: 'Pas de lignes OK dans le fichier | Enregistrement de la ligne OK réussie | Enregistrement des {count} lignes OK réussi',
						validatedBloc: {
							successRows: 'Import de {successCount} lignes sur {rowsCount} en cours',
							importFinished: 'Import validé'
						},
						explanation: 'Le fichier apparaîtra dans l’historique à la prochaine visite',
						importValidatedDeleted: 'L’annulation a été effectuée avec succès',
						downloadingInfoTooltip: 'La durée d’enregistrement des données dépend de la volumétrie du fichier importé'
					},
				undue:
					{
						urls: {
							fetchHistory: '/api/generic-imports/type/undue',
							addFile: '/api/generic-imports/type/undue',
							findImportedFile: '/api/generic-imports/type/undue/latest',
							fetchImportedFile: '/api/generic-imports/type/undue/latest',
							cancelImportedFileAsync: '/api/generic-imports/{genericImportId}/async',
							deleteImportedFile: '/api/generic-imports/{genericImportId}',
							exportImportedFile: '/api/generic-imports/{genericImportId}/file/{status}',
							importFile: '/api/generic-imports/{genericImportId}',
							uploadFile: '/file/upload/undue',
							genericImportConfig: '/api/generic-imports/type/undue/configurations'
						},
						importValidationSuccess: 'Pas de lignes OK dans le fichier | Import de la ligne OK en cours | Import des {count} lignes OK en cours',
						importArchivedSuccess: 'Aucune ligne à sauvegarder dans le fichier | La ligne est sauvegardée | Les {count} lignes sont sauvegardées',
						dataLoadedSuccess: 'Pas de lignes OK dans le fichier | Enregistrement de la ligne OK réussie | Enregistrement des {count} lignes OK réussi',
						validatedBloc: {
							successRows: 'Import de {successCount} lignes sur {rowsCount} en cours',
							importFinished: 'Import validé'
						},
						explanation: 'Le fichier apparaîtra dans l’historique à la prochaine visite',
						importValidatedDeleted: 'L’annulation a été effectuée avec succès',
						downloadingInfoTooltip: 'La durée d’enregistrement des données dépend de la volumétrie du fichier importé'
					},
				claimFile:
					{
						urls: {
							addFile: '/api/generic-imports/type/claim-file',
							uploadFile: '/file/upload/claim_file',
							exportImportedFile: '/api/generic-imports/{genericImportId}/file/{status}'
						}
					},
				stored_file:
					{
						urls: {
							fetchHistory: '/api/generic-imports/type/stored_file',
							addFile: '/api/generic-imports/type/{type}',
							findImportedFile: '/api/generic-imports/type/stored_file/latest',
							fetchImportedFile: '/api/generic-imports/type/stored_file/latest',
							cancelImportedFileAsync: '/api/generic-imports/{genericImportId}/async',
							deleteImportedFile: '/api/generic-imports/{genericImportId}',
							exportImportedFile: '/api/generic-imports/{genericImportId}/file/{status}',
							uploadFile: '/file/upload/file_storage',
							genericImportConfig: '/api/generic-imports/type/stored_file/configurations',
							loadAdvancedSearch: '/api/generic-imports/type/stored_file/advanced-search',
							importForm: '/api/generic-imports/type/stored_file/form',
							downloadingInfoTooltip: 'La durée d’enregistrement des données dépend de la volumétrie du fichier importé'
						}
					}
			}
		},
		'functionality-configuration': {
			type: {
				'billing-information':
					{
						urls: {
							fetchHistory: '/api/projects/{projectToken}/generic-imports/type/billing-information{suffix}',
							addFile: '/api/projects/{projectToken}/generic-imports/type/billing-information',
							findImportedFile: '/api/projects/{projectToken}/generic-imports/type/billing-information/latest',
							fetchImportedFile: '/api/projects/{projectToken}/generic-imports/type/billing-information/latest',
							fetchCurrentRemunerationPeriod: '/api/projects/{projectToken}/generic-imports/type/billing-information/remuneration-periods/current',
							fetchDepositPeriods: '/api/projects/{projectToken}/generic-imports/type/billing-information/deposit-periods',
							cancelImportedFileAsync: '/api/projects/{projectToken}/generic-imports/{genericImportId}/async',
							deleteImportedFile: '/api/projects/{projectToken}/generic-imports/{genericImportId}',
							exportImportedFile: '/api/projects/{projectToken}/generic-imports/{genericImportId}/file/{status}',
							importFile: '/api/projects/{projectToken}/generic-imports/{genericImportId}',
							uploadFile: '/file/upload/billing_information',
							genericImportConfig: '/api/projects/{projectToken}/generic-imports/type/billing-information/configurations',
							importForm: '/api/projects/{projectToken}/generic-imports/type/billing-information/form'
						},
						importValidationSuccess: 'Pas de lignes OK dans le fichier | Validation de la ligne OK réussie | Validation des {count} lignes OK réussie',
						importArchivedSuccess: 'Aucune ligne à sauvegarder dans le fichier | La ligne est sauvegardée | Les {count} lignes sont sauvegardées',
						downloadingInfoTooltip: 'La durée d’enregistrement des données dépend de la volumétrie du fichier importé',
						workInProgressInfoTooltip: 'La durée de validation des données dépend de la volumétrie du fichier importé',
						validatedBloc: {
							successRows: '{successCount} lignes sur {rowsCount} importées avec succès le',
							importFinished: 'Import validé pour la période'
						},
						explanation: 'Le fichier apparaitra dans l’historique au début de la prochaine période',
						importValidatedDeleted: 'L’annulation a été effectuée avec succès'
					},
				'billing-information-without-nomenclature':
					{
						urls: {
							fetchHistory: '/api/projects/{projectToken}/generic-imports/type/billing-information-without-nomenclature{suffix}',
							addFile: '/api/projects/{projectToken}/generic-imports/type/billing-information-without-nomenclature',
							findImportedFile: '/api/projects/{projectToken}/generic-imports/type/billing-information-without-nomenclature/latest',
							fetchImportedFile: '/api/projects/{projectToken}/generic-imports/type/billing-information-without-nomenclature/latest',
							fetchCurrentRemunerationPeriod: '/api/projects/{projectToken}/generic-imports/type/billing-information-without-nomenclature/remuneration-periods/current',
							fetchDepositPeriods: '/api/projects/{projectToken}/generic-imports/type/billing-information-without-nomenclature/deposit-periods',
							cancelImportedFileAsync: '/api/projects/{projectToken}/generic-imports/{genericImportId}/async',
							deleteImportedFile: '/api/projects/{projectToken}/generic-imports/{genericImportId}',
							exportImportedFile: '/api/projects/{projectToken}/generic-imports/{genericImportId}/file/{status}',
							importFile: '/api/projects/{projectToken}/generic-imports/{genericImportId}',
							uploadFile: '/file/upload/billing_information_without_nomenclature',
							genericImportConfig: '/api/projects/{projectToken}/generic-imports/type/billing-information-without-nomenclature/configurations',
							importForm: '/api/projects/{projectToken}/generic-imports/type/billing-information-without-nomenclature/form'
						},
						importValidationSuccess: 'Pas de lignes OK dans le fichier | Validation de la ligne OK réussie | Validation des {count} lignes OK réussie',
						importArchivedSuccess: 'Aucune ligne à sauvegarder dans le fichier | La ligne est sauvegardée | Les {count} lignes sont sauvegardées',
						downloadingInfoTooltip: 'La durée d’enregistrement des données dépend de la volumétrie du fichier importé',
						workInProgressInfoTooltip: 'La durée de validation des données dépend de la volumétrie du fichier importé',
						validatedBloc: {
							successRows: '{successCount} lignes sur {rowsCount} importées avec succès le',
							importFinished: 'Import validé pour la période'
						},
						explanation: 'Le fichier apparaitra dans l’historique au début de la prochaine période',
						importValidatedDeleted: 'L’annulation a été effectuée avec succès'
					},
				'generic-import-contact':
					{
						urls: {
							fetchHistory: '/api/projects/{projectToken}/generic-imports/type/generic-import-contact{suffix}',
							addFile: '/api/projects/{projectToken}/generic-imports/type/{type}',
							findImportedFile: '/api/projects/{projectToken}/generic-imports/type/generic-import-contact/latest',
							fetchImportedFile: '/api/projects/{projectToken}/generic-imports/type/generic-import-contact/latest',
							fetchCurrentRemunerationPeriod: '/api/projects/{projectToken}/type/generic-imports/generic-import-contact/remuneration-periods/current',
							fetchDepositPeriods: '/api/projects/{projectToken}/generic-imports/type/generic-import-contact/deposit-periods',
							cancelImportedFileAsync: '/api/projects/{projectToken}/generic-imports/{genericImportId}/async',
							deleteImportedFile: '/api/projects/{projectToken}/generic-imports/{genericImportId}',
							exportImportedFile: '/api/projects/{projectToken}/generic-imports/{genericImportId}/file/{status}',
							importFile: '/api/projects/{projectToken}/generic-imports/{genericImportId}',
							uploadFile: '/file/upload/import_contact',
							genericImportConfig: '/api/projects/{projectToken}/generic-imports/type/generic-import-contact/configurations',
							importForm: '/api/projects/{projectToken}/generic-imports/type/generic-import-contact/form'
						},
						importValidationSuccess: 'Pas de lignes OK dans le fichier | Importation de la ligne OK réussie | Importation des {count} lignes OK réussie',
						importArchivedSuccess: 'Aucune ligne à sauvegarder dans le fichier | La ligne est sauvegardée | Les {count} lignes sont sauvegardées',
						downloadingInfoTooltip: 'La durée d’enregistrement des données dépend de la volumétrie du fichier importé',
						workInProgressInfoTooltip: 'La durée de validation des données dépend de la volumétrie du fichier importé',
						importValidatedDeleted: 'L’annulation a été effectuée avec succès',
						validatedBloc: {
							successRows: '{successCount} lignes sur {rowsCount} importées avec succès le',
							importFinished: 'Import validé pour la période'
						},
						explanation: 'Le fichier apparaitra dans l’historique au début de la prochaine période.'
					},
				'stored_file':
					{
						urls: {
							fetchHistory: '/api/projects/{projectToken}/generic-imports/type/stored_file{suffix}',
							addFile: '/api/projects/{projectToken}/generic-imports/type/{type}',
							findImportedFile: '/api/projects/{projectToken}/generic-imports/type/stored_file/latest',
							fetchImportedFile: '/api/projects/{projectToken}/generic-imports/type/stored_file/latest',
							fetchCurrentRemunerationPeriod: '/api/projects/{projectToken}/generic-imports/type/stored_file/remuneration-periods/current',
							fetchDepositPeriods: '/api/projects/{projectToken}/generic-imports/type/stored_file/deposit-periods',
							cancelImportedFileAsync: '/api/projects/{projectToken}/generic-imports/{genericImportId}/async',
							deleteImportedFile: '/api/projects/{projectToken}/generic-imports/{genericImportId}',
							exportImportedFile: '/api/projects/{projectToken}/generic-imports/{genericImportId}/file/{status}',
							uploadFile: '/file/upload/file_storage',
							genericImportConfig: '/api/projects/{projectToken}/generic-imports/type/stored_file/configurations',
							loadAdvancedSearch: '/api/projects/{projectToken}/generic-imports/type/stored_file/advanced-search',
							importForm: '/api/projects/{projectToken}/generic-imports/type/stored_file/form'
						}
					},
				'generic-import-actor':
					{
						urls: {
							fetchHistory: '/api/projects/{projectToken}/generic-imports/type/generic-import-actor{suffix}',
							addFile: '/api/projects/{projectToken}/generic-imports/type/generic-import-actor',
							findImportedFile: '/api/projects/{projectToken}/generic-imports/type/generic-import-actor/latest',
							fetchImportedFile: '/api/projects/{projectToken}/generic-imports/type/generic-import-actor/latest',
							cancelImportedFileAsync: '/api/projects/{projectToken}/generic-imports/{genericImportId}/async',
							deleteImportedFile: '/api/projects/{projectToken}/generic-imports/{genericImportId}',
							exportImportedFile: '/api/projects/{projectToken}/generic-imports/{genericImportId}/file/{status}',
							importFile: '/api/projects/{projectToken}/generic-imports/{genericImportId}',
							uploadFile: '/file/upload/actor',
							genericImportConfig: '/api/projects/{projectToken}/generic-imports/type/generic-import-actor/configurations',
							importForm: '/api/projects/{projectToken}/generic-imports/type/generic-import-actor/form'
						},
						importValidationSuccess: 'Pas de lignes OK dans le fichier | Validation de la ligne OK réussie | Validation des {count} lignes OK réussie',
						importArchivedSuccess: 'Aucune ligne à sauvegarder dans le fichier | La ligne est sauvegardée | Les {count} lignes sont sauvegardées',
						downloadingInfoTooltip: 'La durée d’enregistrement des données dépend de la volumétrie du fichier importé',
						workInProgressInfoTooltip: 'La durée de validation des données dépend de la volumétrie du fichier importé',
						validatedBloc: {
							successRows: '{successCount} lignes sur {rowsCount} importées avec succès le',
							importFinished: 'Import validé'
						},
						explanation: 'Le fichier apparaitra dans l’historique à la prochaine visite',
						importValidatedDeleted: 'L’annulation a été effectuée avec succès'
					},
				'addressing-information':
					{
						urls: {
							fetchHistory: '/api/projects/{projectToken}/generic-imports/type/addressing-information{suffix}',
							addFile: '/api/projects/{projectToken}/generic-imports/type/addressing-information',
							findImportedFile: '/api/projects/{projectToken}/generic-imports/type/addressing-information/latest',
							fetchImportedFile: '/api/projects/{projectToken}/generic-imports/type/addressing-information/latest',
							genericImportConfig: '/api/projects/{projectToken}/generic-imports/type/addressing-information/configurations',
							importForm: '/api/projects/{projectToken}/generic-imports/type/addressing-information/form',
							cancelImportedFileAsync: '/api/projects/{projectToken}/generic-imports/{genericImportId}/async',
							deleteImportedFile: '/api/projects/{projectToken}/generic-imports/{genericImportId}',
							exportImportedFile: '/api/projects/{projectToken}/generic-imports/{genericImportId}/file/{status}',
							importFile: '/api/projects/{projectToken}/generic-imports/{genericImportId}',
							uploadFile: '/file/upload/addressing_information'
						},
						importValidationSuccess: 'Pas de lignes OK dans le fichier | Validation de la ligne OK réussie | Validation des {count} lignes OK réussie',
						importArchivedSuccess: 'Aucune ligne à sauvegarder dans le fichier | La ligne est sauvegardée | Les {count} lignes sont sauvegardées',
						downloadingInfoTooltip: 'La durée d’enregistrement des données dépend de la volumétrie du fichier importé',
						workInProgressInfoTooltip: 'La durée de validation des données dépend de la volumétrie du fichier importé',
						validatedBloc: {
							successRows: '{successCount} lignes sur {rowsCount} importées avec succès le',
							importFinished: 'Import validé'
						},
						explanation: 'Le fichier apparaitra dans l’historique à la prochaine visite',
						importValidatedDeleted: 'L’annulation a été effectuée avec succès'
					},
				'generic-import-control-file':
					{
						urls: {
							fetchHistory: '/api/projects/{projectToken}/generic-imports/type/generic-import-control-file{suffix}',
							addFile: '/api/projects/{projectToken}/generic-imports/type/generic-import-control-file',
							findImportedFile: '/api/projects/{projectToken}/generic-imports/type/generic-import-control-file/latest',
							fetchImportedFile: '/api/projects/{projectToken}/generic-imports/type/generic-import-control-file/latest',
							cancelImportedFileAsync: '/api/projects/{projectToken}/generic-imports/{genericImportId}/async',
							deleteImportedFile: '/api/projects/{projectToken}/generic-imports/{genericImportId}',
							exportImportedFile: '/api/projects/{projectToken}/generic-imports/{genericImportId}/file/{status}',
							importFile: '/api/projects/{projectToken}/generic-imports/{genericImportId}',
							uploadFile: '/file/upload/actor',
							genericImportConfig: '/api/projects/{projectToken}/generic-imports/type/generic-import-control-file/configurations',
							importForm: '/api/projects/{projectToken}/generic-imports/type/generic-import-control-file/form'
						},
						importValidationSuccess: 'Pas de lignes OK dans le fichier | Validation de la ligne OK réussie | Validation des {count} lignes OK réussie',
						importArchivedSuccess: 'Aucune ligne à sauvegarder dans le fichier | La ligne est sauvegardée | Les {count} lignes sont sauvegardées',
						downloadingInfoTooltip: 'La durée d’enregistrement des données dépend de la volumétrie du fichier importé',
						workInProgressInfoTooltip: 'La durée de validation des données dépend de la volumétrie du fichier importé',
						validatedBloc: {
							successRows: '{successCount} lignes sur {rowsCount} importées avec succès le',
							importFinished: 'Import validé'
						},
						explanation: 'Le fichier apparaitra dans l’historique à la prochaine visite',
						importValidatedDeleted: 'L’annulation a été effectuée avec succès'
					}
			}
		}
	},
	title: 'Fichier de facturation',
	remunerationTitle: 'Fichier de facturation',
	deadline: 'Date limite d’import : {endDate}',
	infoTitle: 'L’import du fichier se déroule en deux étapes :',
	firstInfo: 'Après sélection du fichier, les données sont contrôlées par la plateforme.',
	secondInfo: 'La synthèse de ces contrôles est ensuite affichée. Si les résultats sont concluants, vous devez les valider pour finaliser l’import du fichier.',
	cancelImportProcess: 'Annuler',
	statusLabel: {
		Waiting: 'En attente de traitement...',
		WorkInProgress: 'Contrôle des données...',
		Checked: 'Données vérifiées',
		Cancelled: 'Annulation du traitement...',
		Validated: 'Traitement validé',
		DataLoading: 'Enregistrement des données...',
		DataPersisting: 'Finalisation du traitement...',
		Failed: 'Échec du traitement',
		Archived: 'Fin du traitement'
	},
	lockedDateText: 'Prochaine ouverture de l’import dans',
	remainingTimeBeforeLockedDate: '{hours}h {restOfMinutes}min',
	lockedDateSubtitle: 'Import temporairement fermé pour traitement',
	cancelPopup: {
		text: 'Êtes-vous sûr de vouloir annuler le traitement du fichier ?',
		cancelBtnText: 'Non',
		confirmBtnText: 'Oui'
	},
	confirmPopup: {
		title: 'Remplacer le dernier fichier de contrôle',
		text: 'En important ce fichier, l’ancien fichier enregistré sera supprimé.',
		subText: 'Souhaitez‑vous tout de même procéder à l\'import de ce fichier ?',
		cancelBtnText: 'Non',
		confirmBtnText: 'Oui'
	},
	processingMessage: 'Traitement des données',
	validatedBloc: {
		replace: 'Remplacer le fichier',
		deleteText: 'Êtes-vous sûr de vouloir supprimer le fichier de facturation importé ?'
	},
	popupValidation: {
		title: 'Contrôle de votre fichier avant import',
		resultLabel: 'Résultats de l’import',
		cancelBtnText: 'Annuler l’import',
		confirmBtnText: 'Valider l’import',
		exportBtnText: 'Exporter Les résultats'
	},
	periods: {
		title: 'Période :',
		closed: 'Cette période d’import a été clôturée.',
		mention: 'Retrouvez le dernier fichier importé utilisé pour le calcul des rémunérations dans l’historique ci-dessous.'
	}
};
